import { FindClassificationTypesToOfflineOutput } from '../../../../../../../../../services/modules/classificationTypes/classificationTypes.types';
import { OfflineDatabaseClassificationType } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseClassificationType.types';
import { offlineClassificationTypesRepository } from '../../../../../../../repositories/offlineClassificationTypes.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class ClassificationTypesQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindClassificationTypesToOfflineOutput>({
      url: '/classification-types/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineClassificationTypesRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(
    data: FindClassificationTypesToOfflineOutput,
  ): OfflineDatabaseClassificationType {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      useAsTag: data.useAsTag,
      useAsFilter: data.useAsFilter,
    };
  }
}
